import {ApiDefinition} from "./ApiDefinition";
import {ActionInstanceJob, MigrationActionInfo} from "./model/migrations/types";


class MigrationsApiDefinition extends ApiDefinition {
    constructor() {
        super("/migrations");
    }

    async getMigrations() {
        return this.get<Array<string>>("/types");
    }

    async getMigrationActions(migrationType: string) {
        return this.get<Array<MigrationActionInfo>>(`/${migrationType}/actions`);
    }

    async getActionJobInfo(migration: string, action: string, timestamp: string) {
        return this.get<ActionInstanceJob>(`/${migration}/${action}/${timestamp}/job`);
    }

    async getActionJobTimes(migration: string, action: string) {
        return this.get<Array<string>>(`/${migration}/${action}/jobs/times`);
    }

    async runMigrationAction(params: {migration: string, action: string, data?: Record<string, string | null>
}) {
        console.log("runMigrationAction", params);
        const ret = this.post<string, Record<string, string | null>>(`/${params.migration}/${params.action}/run`, params.data);
        console.log("runMigrationAction", ret);
        return ret;
    }
}

export const MigrationsApi = new MigrationsApiDefinition();